module.exports = __webpack_public_path__ + "static/media/project-thumbnail06.19fe9475.jpg";